/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

export function isValidEmail(email) {
	return email && email.toLowerCase().match(/^\S+@\S+\.\S+$/);
}

/**
 * Turns PascalCase or camelCase string into Sentence case
 * @param {String} s
 */
export const toSentenceCase = (s) => {
	return (
		s &&
		s
			.replace(/([A-Z][a-z])/g, (v) => ` ${v.toLowerCase()}`)
			.replace(/([A-Z][A-Z]+)/g, " $1")
			.trim()
			.replace(/^./, (str) => {
				return str.toUpperCase();
			})
	);
};

/**
 * Turns milliseconds to nice time format of HH:MM:SS. If less than 1 hour this funtion will just return MM:SS
 * @param {*} milliseconds The milliseconds to be converted.
 * @returns A string formatted to HH:MM:SS or MM:SS depending on whether the amount of milliseconds is more than an hour.
 */
export const msToTime = (milliseconds) => {
	var seconds = Math.floor((milliseconds / 1000) % 60),
		minutes = Math.floor((milliseconds / (1000 * 60)) % 60),
		hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);

	hours = hours < 10 ? "0" + hours : hours;
	minutes = minutes < 10 ? "0" + minutes : minutes;
	seconds = seconds < 10 ? "0" + seconds : seconds;

	return `${hours > 0 ? `${hours}:` : ""}${minutes}:${seconds}`;
};

/**
 * Checks for overlapping values in two min, max range pairs.
 * @param {Array} range1 An array containing a maximum and minimum value.
 * @param {Array} range2 An array containing a maximum and minimum value.
 */
export function testForRangeOverlap(range1, range2) {
	return (
		(range1[0] >= range2[0] && range1[0] <= range2[1]) ||
		(range1[1] >= range2[0] && range1[1] <= range2[1]) ||
		(range1[0] <= range2[0] && range1[1] >= range2[1])
	);
}

/**
 * Checks common strings and numbers that can represent a boolean and returns true/false
 * @param {String | Number} val value to convert
 */
export const valToBool = (val) => {
	if (typeof val === "string") {
		val = val.trim().toLowerCase();
	}

	switch (val) {
		case true:
		case "true":
		case 1:
		case "1":
		case "on":
		case "yes":
			return true;
		default:
			return false;
	}
};

/**
 * This method takes in a navigation module object and searches for the deepest subpath in that module that is
 * included in the window.location.pathname string.
 * @param {Object} navigationModule The module to search for a selected subpath withen.
 * @returns The deepest subpath object or undefined.
 */
export const findDeepestSubPath = (navigationModule) => {
	let newSelectedSubPath = undefined;
	navigationModule.subpaths.forEach((subpath) => {
		/*
			If we do not have a selected Subpath or 
			the length of subpath is greater than the length of the selectedsubpath
			then we check for the subpath in the windows current location.
			If true this means that the subpath is the closer match to the current location.
		*/
		const deeperPath = navigationModule && subpath.path.length >= navigationModule.path.length;
		if ((!newSelectedSubPath || deeperPath) && window.location.pathname.includes(subpath.path)) {
			newSelectedSubPath = subpath;
		}
	});
	return newSelectedSubPath;
};

/**
 * This method takes in a String and validates for UUID format. ie.   8-4-4-4-12 chars.
 * included in the window.location.pathname string.
 * @param {string} UUID
 * @returns {boolean} true / false.
 */
export function checkIfValidUUID(str) {
	// Regular expression to check if string is a valid UUID
	const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

	return regexExp.test(str);
}
